<nav class="presentation-bottom-nav md:hidden" [attr.aria-label]="'PROJECTS_NAVIGATION' | translate">
  <ul>
    <li>
      <a routerLink="/about" routerLinkActive="active" ariaCurrentWhenActive="page">
        {{ 'ABOUT_TITLE' | translate }}
      </a>
    </li>
    <li>
      <a routerLink="/portfolio" routerLinkActive="active" ariaCurrentWhenActive="page">
        {{ 'PORTFOLIO_TITLE' | translate }}
      </a>
    </li>
    <li>
      <a routerLink="/school-career" routerLinkActive="active" ariaCurrentWhenActive="page">
        {{ 'SCHOOL_CAREER_TITLE' | translate }}
      </a>
    </li>
    <li>
      <a routerLink="/contact" routerLinkActive="active" ariaCurrentWhenActive="page">
        {{ 'CONTACT_TITLE' | translate }}
      </a>
    </li>
  </ul>
</nav>
